import { translate } from '../../common/utility/DisplayPrep';

const { _READ_ONLY_FEATURES } = process.env; // Global read-only flag
const READ_ONLY_FEATURES = true; // Module read-only flag

const typeEnum = {
    CDM: 'Concept Determination Method',
    JURISDICTION: 'Jurisdiction',
    KM: 'Knowledge Module'
};

const environmentEnum = {
    PRODUCTION: 'Production',
    TEST: 'Test'
};

const operationEnum = {
    DEPLOY: 'Deploy',
    UNDEPLOY: 'Undeploy'
};

const statusEnum = {
    PENDING: 'Pending',
    PROCESSING: 'Processing',
    TIMED_OUT: 'Timed Out',
    SUCCESS: 'Success',
    ERROR: 'Error'
};

const actions = _READ_ONLY_FEATURES === 'true' ? ['view'] : ['view', 'delete'];

const uiConfig = {
    name: 'Deployment Queue',
    withActions: actions,
    primaryKey: 'deploymentId',
    properties: {
        deploymentId: {
            name: 'Deployment ID',
            rowDisplay: false,
            editable: false,
            nullable: false
        },
        deploymentType: {
            name: 'Type',
            options: typeEnum,
            input: !READ_ONLY_FEATURES ? 'select' : 'valueDisplay',
            rowDisplay: true,
            filterable: true,
            editable: !READ_ONLY_FEATURES,
            nullable: false,
            postChangeBind: (v, onChange) => {
                onChange('deploymentType', typeEnum[v], true);
            }
        },
        deploymentOperation: {
            name: 'Operation',
            options: operationEnum,
            input: !READ_ONLY_FEATURES ? 'select' : 'valueDisplay',
            rowDisplay: true,
            filterable: true,
            editable: !READ_ONLY_FEATURES,
            nullable: false,
            postChangeBind: (v, onChange) => {
                onChange('deploymentOperation', operationEnum[v], true);
            }
        },
        environment: {
            name: 'Environment',
            options: environmentEnum,
            input: !READ_ONLY_FEATURES ? 'select' : 'valueDisplay',
            rowDisplay: true,
            filterable: true,
            editable: !READ_ONLY_FEATURES,
            nullable: false,
            postChangeBind: (v, onChange) => {
                onChange('environment', environmentEnum[v], true);
            }
        },
        businessId: {
            name: 'Business ID',
            rowDisplay: false,
            input: !READ_ONLY_FEATURES ? 'text' : 'valueDisplay',
            editable: !READ_ONLY_FEATURES,
            nullable: true
        },
        scopingEntityId: {
            name: 'Scoping Entity ID',
            rowDisplay: true,
            filterable: true,
            input: !READ_ONLY_FEATURES ? 'text' : 'valueDisplay',
            editable: !READ_ONLY_FEATURES,
            nullable: true
        },
        code: {
            name: 'Code',
            rowDisplay: false,
            filterable: true,
            input: !READ_ONLY_FEATURES ? 'text' : 'valueDisplay',
            editable: !READ_ONLY_FEATURES,
            nullable: true
        },
        codeSystem: {
            name: 'Code System',
            rowDisplay: false,
            input: !READ_ONLY_FEATURES ? 'text' : 'valueDisplay',
            editable: !READ_ONLY_FEATURES,
            nullable: true
        },
        status: {
            name: 'Status',
            options: statusEnum,
            input: !READ_ONLY_FEATURES ? 'select' : 'valueDisplay',
            rowDisplay: true,
            filterable: true,
            editable: false,
            nullable: false,
            postChangeBind: (v, onChange) => {
                onChange('status', statusEnum[v], true);
            }
        },
        statusCode: {
            name: 'Status Code',
            rowDisplay: true,
            editable: false,
            input: 'valueDisplay'
        },
        deploymentDate: {
            name: 'Queued',
            rowDisplay: true,
            editable: false,
            additionalProperties: {
                Cell: ({ cell: { value } }) => {
                    return translate.ReadableDateTimeColumn(value);
                }
            }
        },
        deployedOn: {
            name: 'Deployed',
            rowDisplay: true,
            editable: false,
            additionalProperties: {
                Cell: ({ cell: { value } }) => {
                    return translate.ReadableDateTimeColumn(value);
                }
            }
        },
        retrievedCount: {
            name: 'Runs',
            rowDisplay: true,
            editable: false
        },
        message: {
            name: 'Message',
            rowDisplay: false,
            input: !READ_ONLY_FEATURES ? 'multiline' : 'valueDisplayMultiline',
            editable: false,
            inputProps: {
                height: '15rem'
            }
        },
        createDatetime: {
            name: 'Created Datetime',
            rowDisplay: false,
            editable: false
        },
        createId: {
            name: 'Created by',
            rowDisplay: false,
            editable: false
        },
        dtoState: {
            name: 'DTO State',
            rowDisplay: false,
            editable: false
        },
        lastModDatetime: {
            name: 'Last Modified',
            rowDisplay: false,
            editable: false
        },
        lastModId: {
            name: 'Last Modified By',
            rowDisplay: false,
            editable: false
        },
        uuid: {
            name: 'UUID',
            rowDisplay: false,
            editable: false
        }
    },
    newDoc: {
        deploymentType: null,
        deploymentOperation: null,
        environment: null,
        dtoState: 'NEW',
        deploymentId: null,
        businessId: null,
        scopingEntityId: null,
        code: null,
        codeSystem: null,
        deploymentDate: new Date()
    },
    sortBy: {
        columnId: 'deploymentDate',
        desc: true
    }
};

export default uiConfig;
